import IconButton from '@mui/material/IconButton';
import { generateLinkByEmail } from 'framework/utils';
import { useFieldHelper } from 'framework/ui/field';
import { TeamsIcon } from 'framework/ui/mui-builder';

interface LinkIconButtonEmployeeTeamsProps {
  employeeEmailValue?: string;
  employeeEmailSource?: string;
  size?: 'small' | 'medium' | 'large';
}

const SIZE_MAP = {
  small: { button: 24, icon: 13 },
  medium: { button: 36, icon: 26 },
  large: { button: 48, icon: 32 },
};

const LinkIconButtonEmployeeTeams = ({
  employeeEmailSource,
  employeeEmailValue,
  size = 'small',
}: LinkIconButtonEmployeeTeamsProps) => {
  const { getValue: getWorkingEmail } = useFieldHelper({ value: employeeEmailValue, source: employeeEmailSource });
  const workingEmail = getWorkingEmail();

  const handleTeamsButton = () => {
    const teamsLink = generateLinkByEmail(workingEmail);
    window.open(teamsLink, '_blank');
  };

  if (!workingEmail) return null;

  const { button: buttonSize, icon: iconSize } = SIZE_MAP[size];

  return (
    <IconButton
      onClick={handleTeamsButton}
      size={size}
      sx={{
        width: buttonSize,
        height: buttonSize,
        padding: '5px',
        mr: '10px',
      }}
    >
      <TeamsIcon sx={{ fontSize: iconSize }} />
    </IconButton>
  );
};

export default LinkIconButtonEmployeeTeams;
